import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const PrivacyPolicy = () => {
  return (
    <div
      className="min-h-screen flex justify-center items-center p-12"
      dir="rtl"
    >
      <Card className="shadow-lg border-0 mx-auto max-w-4xl">
        <CardHeader>
          <CardTitle className="text-3xl font-bold text-gray-900 border-b-2 border-(--primary-color-light) w-fit mx-auto pb-2">
            سياسة الخصوصية
          </CardTitle>
        </CardHeader>

        <CardContent className="space-y-8 text-gray-700 leading-relaxed px-12">
          {/* المعلومات التي نقوم بجمعها */}
          <div>
            <h2 className="text-xl font-semibold mb-2">
              المعلومات التي نجمعها
            </h2>
            <p>نجمع المعلومات الشخصية عندما تقوم بـ:</p>
            <ul className="list-disc ml-6 space-y-1">
              <li>
                إنشاء حساب (الاسم، البريد الإلكتروني، رقم الهاتف، صورة الملف
                الشخصي)
              </li>
              <li>
                استخدام خدماتنا (عنوان IP، معلومات الجهاز، سجلات الاستخدام)
              </li>
              <li>
                المشاركة في الحصص المباشرة (الصوت، الفيديو، رسائل الدردشة)
              </li>
            </ul>
          </div>

          {/* كيف نستخدم معلوماتك */}
          <div>
            <h2 className="text-xl font-semibold mb-2">
              كيفية استخدام معلوماتك
            </h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>تقديم وصيانة خدماتنا</li>
              <li>التواصل معك بشأن التحديثات أو التغييرات الهامة</li>
              <li>تحسين تجربتك وتخصيصها</li>
              <li>مراقبة الأمان ومنع الاحتيال</li>
            </ul>
          </div>

          {/* حماية بياناتك */}
          <div>
            <h2 className="text-xl font-semibold mb-2">كيفية حماية بياناتك</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>نستخدم خوادم آمنة وتشفير (SSL) وضوابط وصول صارمة.</li>
              <li>لا نقوم ببيع بياناتك الشخصية لأي طرف ثالث.</li>
              <li>
                يقتصر الوصول إلى بيانات الطلاب على الموظفين أو المعلمين المخولين
                فقط.
              </li>
            </ul>
          </div>

          {/* مشاركة البيانات */}
          <div>
            <h2 className="text-xl font-semibold mb-2">مشاركة البيانات</h2>
            <p>
              قد نشارك بياناتك مع مزودي الخدمات الموثوقين بموجب اتفاقيات سرية،
              أو مع الجهات الرسمية إذا تطلب القانون ذلك.
            </p>
          </div>

          {/* حقوقك */}
          <div>
            <h2 className="text-xl font-semibold mb-2">حقوقك</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>الاطلاع على بياناتك الشخصية أو تعديلها أو حذفها</li>
              <li>طلب حذف حسابك في أي وقت</li>
              <li>إلغاء الاشتراك في الرسائل التسويقية</li>
              <li>
                يمكن للوالدين أو الأوصياء إدارة بيانات الطالب في حالة القُصّر
              </li>
            </ul>
          </div>

          {/* الكوكيز وتقنيات التتبع */}
          <div>
            <h2 className="text-xl font-semibold mb-2">
              ملفات تعريف الارتباط والتتبع
            </h2>
            <p>
              نستخدم ملفات تعريف الارتباط لتذكر تسجيل الدخول وتخصيص المحتوى
              وتحليل الاستخدام. يمكنك تعطيل الكوكيز من خلال متصفحك، لكن قد لا
              تعمل بعض الميزات بشكل كامل.
            </p>
          </div>

          {/* خصوصية الأطفال */}
          <div>
            <h2 className="text-xl font-semibold mb-2">خصوصية الأطفال</h2>
            <p>
              منصتنا مخصصة للطلاب تحت إشراف الأهل أو المعلمين. لا نجمع معلومات
              من الأطفال دون سن ١٣ عامًا بدون موافقة.
            </p>
          </div>

          {/* الاحتفاظ بالبيانات */}
          <div>
            <h2 className="text-xl font-semibold mb-2">الاحتفاظ بالبيانات</h2>
            <p>
              نحتفظ بمعلوماتك فقط للمدة اللازمة للأغراض القانونية أو التعليمية.
              بعد إغلاق الحساب، قد نحتفظ ببعض البيانات لأغراض أمنية وقانونية.
            </p>
          </div>

          {/* التحديثات */}
          <div>
            <h2 className="text-xl font-semibold mb-2">
              تحديثات سياسة الخصوصية
            </h2>
            <p>
              قد نقوم بتحديث سياسة الخصوصية من حين لآخر، وسنخطرك بأي تغييرات
              جوهرية عبر البريد الإلكتروني أو داخل المنصة.
            </p>
          </div>

          {/* التواصل معنا */}
          <div>
            <h2 className="text-xl font-semibold mb-2">التواصل معنا</h2>
            <p>
              إذا كان لديك أي أسئلة أو طلبات تتعلق بالخصوصية، يرجى التواصل معنا
              عبر:
              <br />
              📧 qashqool.edu@gmail.com
              <br />
              📞 +201012376009 (واتساب)
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PrivacyPolicy;
